// One day's card: a muted date header row, then its transaction rows. The
// feed displays loaded rows and server-provided completeness only; it does
// not calculate a partial-page day aggregate.
import type { TransactionRow } from '@/api/hooks/useTransactions';
import { FeedRow } from './FeedRow';

export function FeedDayGroup({
  label,
  rows,
}: {
  label: string;
  rows: TransactionRow[];
}) {
  return (
    <section data-testid="feed-day-group" className="mb-3">
      <div className="mb-1.5 text-xs text-muted-foreground">{label}</div>
      <div className="rounded-lg border border-border bg-card" data-testid="feed-day-rows">
        {rows.map((row) => (
          <FeedRow key={row.transaction_id} txn={row} />
        ))}
      </div>
    </section>
  );
}

export default FeedDayGroup;
